import {
  compareDmyDates,
  compareText,
  countryLabelOptions,
  pluckUniqueTruthyValues,
  sortRows,
} from './tableUtils';

export const INITIAL_FILTERS = {
  name: '',
  market: '',
  country: '',
  status: '',
  retailer: '',
  invitation: '',
  pma: '',
};

export const SORT_FIELDS = {
  NAME: 'name',
  LAST_NAME: 'last_name',
  PMA_EMAIL: 'first_pma_email',
  INVITATION: 'invitation',
  LAST_UPDATE: 'last_update',
};

export const EMAIL_STATUS_KEYS = {
  BOUNCED: 'common-edm-bounced',
  SENT: 'common-edm-send',
  OPENED: 'common-edm-open',
  CLICKED: 'common-edm-click',
};

export const ADMIN_HAC_FILTERS_KEY = 'admin-hac-filters';

const EMPTY_STRING = '';

export const normalizeEmailStatus = (emailStatus) => ({
  bounce: Boolean(emailStatus?.bounce),
  send: Boolean(emailStatus?.send),
  open: Boolean(emailStatus?.open),
  click: Boolean(emailStatus?.click),
});

export const normalizeHacRow = (row = {}) => ({
  ...row,
  name: row?.name || EMPTY_STRING,
  last_name: row?.last_name || EMPTY_STRING,
  first_pma_email: row?.first_pma_email || EMPTY_STRING,
  last_update: row?.last_update || EMPTY_STRING,
  email_status: normalizeEmailStatus(row?.email_status),
});

export const sortByLastUpdateDesc = (rows = []) => {
  return sortRows(rows, SORT_FIELDS.LAST_UPDATE, 'desc', SORT_COMPARATORS);
};

export const getUniqueValues = (rows = [], key) => pluckUniqueTruthyValues(rows, key);

export const getEmailStatusLabel = (row) => {
  const emailStatus = normalizeEmailStatus(row?.email_status);

  if (emailStatus.bounce) {
    return EMAIL_STATUS_KEYS.BOUNCED;
  }

  if (emailStatus.send && !emailStatus.open && !emailStatus.click) {
    return EMAIL_STATUS_KEYS.SENT;
  }

  if (emailStatus.send && emailStatus.open && !emailStatus.click) {
    return EMAIL_STATUS_KEYS.OPENED;
  }

  if (emailStatus.send && emailStatus.open && emailStatus.click) {
    return EMAIL_STATUS_KEYS.CLICKED;
  }

  return EMPTY_STRING;
};

export const sortCountriesByLabel = (countries = [], t) => {
  return countryLabelOptions(countries, t);
};

const compareByName = (a, b) => {
  const rowA = normalizeHacRow(a);
  const rowB = normalizeHacRow(b);
  return compareText(rowA.name, rowB.name);
};

const compareByLastName = (a, b) => {
  const rowA = normalizeHacRow(a);
  const rowB = normalizeHacRow(b);
  return compareText(rowA.last_name, rowB.last_name);
};

const compareByPmaEmail = (a, b) => {
  const rowA = normalizeHacRow(a);
  const rowB = normalizeHacRow(b);
  const emailA = rowA.first_pma_email;
  const emailB = rowB.first_pma_email;

  if (emailA === '' && emailB !== '') return 1;
  if (emailA !== '' && emailB === '') return -1;

  return compareText(emailA, emailB);
};

const compareByLastUpdate = (a, b) => {
  const rowA = normalizeHacRow(a);
  const rowB = normalizeHacRow(b);
  return compareDmyDates(rowA.last_update, rowB.last_update);
};

const compareByInvitation = (a, b) => {
  return compareText(getEmailStatusLabel(a), getEmailStatusLabel(b));
};

const SORT_COMPARATORS = {
  [SORT_FIELDS.NAME]: compareByName,
  [SORT_FIELDS.LAST_NAME]: compareByLastName,
  [SORT_FIELDS.PMA_EMAIL]: compareByPmaEmail,
  [SORT_FIELDS.INVITATION]: compareByInvitation,
  [SORT_FIELDS.LAST_UPDATE]: compareByLastUpdate,
};

export const sortHacRows = (rows = [], orderBy, order) => {
  return sortRows(rows, orderBy, order, SORT_COMPARATORS);
};

export const getSortedData = (rows = [], orderBy, order) => sortHacRows(rows, orderBy, order);
